module.exports = __webpack_public_path__ + "static/media/botanyeamcet.be0356dd.png";